<template>
  <div class="project">
    <project-header :project="project"></project-header>

    <div class="project-gallery row">
      <div class="col-12 project-gallery__img">
        <img src="/static/images/incubes/render-1.jpg" class="project-gallery__image">
      </div>
      <div class="col-12 of-hidden video-fix">
        <video class="project-gallery__fullsize-video" playsinline muted loop>
          <source src="/static/videos/incubes/gif-logo-1.mp4">
        </video>
      </div>
      <div class="col-12 project-gallery__img project-gallery__img--incubes-logo">
        <img class="project-gallery__image" src="/static/images/incubes/incubes-logo-2.svg">
      </div>
      <div class="col-12 project-gallery__color-type">
          <img src="/static/images/incubes/Font.svg">
          <img src="/static/images/incubes/colours.svg">
      </div>
      <div class="col-12 project-gallery__video-container project-gallery__double-video project-gallery__double-video--incubes">
        <video class="col-12 col-5-sm project-gallery__video" playsinline muted loop>
          <source src="/static/videos/incubes/gif-shapes-1.mp4">
        </video>
        <video class="col-12 col-5-sm project-gallery__video" playsinline muted loop>
          <source src="/static/videos/incubes/gif-shapes-2.mp4">
        </video>
      </div>
      <div class="col-12 project-gallery__video-container">
        <video class="col-12 col-8-sm project-gallery__video" playsinline muted loop>
          <source src="/static/videos/incubes/gif-poster-1.mp4">
        </video>
      </div>
      <div class="col-12 project-gallery__img" v-for="image in secondSection" :key="image">
        <img class="project-gallery__image" :src="`/static/images/incubes/${image}`">
      </div>
      <div class="col-12">
      <video class="project-gallery__fullsize-video" playsinline muted loop>
        <source src="/static/videos/incubes/gif-incubes-presentation-brochure.mp4">
      </video>
      </div>
      <div class="col-12 project-gallery__img" v-for="image in thirdSection" :key="image">
        <img class="project-gallery__image" :src="`/static/images/incubes/${image}`">
      </div>
      <div class="col-12 project-gallery__video-container">
        <website-video :sources="[ '/static/videos/incubes/Incubes-15-inches-scroll.mp4']"></website-video>
      </div>
    </div>
    <project-footer prev="/work/by-wood" next="/work/clean-sound"></project-footer>
  </div>
</template>

<script>
import project from '../../mixins/project'
import automaticallyPlayVideo from '../../mixins/automaticallyPlayVideo'
import projects from '../../projects'

export default {
  name: 'incubes',
  data () {
    return {
      firstSection: [
        'Font.svg'
      ],
      secondSection: [
        'poster-1-2-web.jpg',
        'poster-5-6-web.jpg',
        'poster-7-8-web.jpg',
        'incubes-brochure-web.jpg',
        'envelope-1-2.jpg',
        'business-card-1-web.jpg',
        'incubes-stationery-1-web.jpg'
      ],
      thirdSection: [
        'incubes-t-shirts-web.jpg',
        'tote-1-2-web.jpg',
        'incubes-mobile-all.jpg'
      ],
      project: projects.find(project => project.title === 'Incubes')
    }
  },
  mixins: [
    project,
    automaticallyPlayVideo
  ]
}
</script>

<style lang="sass">
@import "../../assets/sass/utilities/variables"
@import "../../assets/sass/utilities/mixins"

.project-gallery.row
  justify-content: center

.project-gallery__video-container
  background: #efefef
  padding-top: 50px
  padding-bottom: 50px
  display: flex
  justify-content: space-between
  flex-direction: column
  margin-bottom: $column-gap
  video
    margin-left: auto
    margin-right: auto
  +small
    padding-left: 5%
    padding-right: 5%
  +medium
    flex-direction: row
    padding-top: 75px
    padding-bottom: 75px
    padding-left: 10%
    padding-right: 10%

.project-gallery__image
  width: 100%
  max-width: 100%
  margin-left: auto
  margin-right: auto
  display: inline-block

.project-gallery__video
  max-width: 75vw
  height: 100%
  display: block
  margin-left: auto
  margin-right: auto
  border: none
  +small
    max-width: 401px
  +medium
    max-width: 501px

.project-gallery__fullsize-video
  background-color: white
  border: none
  width: 100%
  border: 1px solid white
  // box-sizing: content-box
  object-fit: cover
  background: none

.video-fix
  position: relative
  width: 100%
  text-align: center
  &::after
    content: ''
    width: 100%
    height: 100%
    // background-color: red
    // border:  10px solid white
    position: absolute
    top: 0
    left: 0


.project-gallery__img--incubes-logo
  background: white
  display: flex
  justify-content: center
  align-items: center
  img
    max-width: 600px

.project-gallery__double-video
  &--incubes
    flex-direction: column
    flex-wrap: nowrap !important
    video:last-of-type
      margin-top: 0
      +small
        margin-top: 0 !important
      +medium
        margin-top: 0
    @media (min-width: 500px)
      flex-direction: row
  video
    margin-left: auto
    margin-right: auto
    &:last-of-type
      margin-top: 50px
      +small
        margin-top: 75px
      +medium
        margin-top: 0
    +medium
      max-width: 30%

.project-gallery__color-type
  display: flex
  margin-top: 50px
  margin-bottom: 50px
  width: 100%
  flex-direction: column
  +medium
    flex-direction: row
    margin-top: 100px
    margin-bottom: 100px
    img
      width: 100%
      height: 500px

</style>



// WEBPACK FOOTER //
// Incubes.vue?77f28be2